export type SupabaseProviderId =
  | "quiyvrsgsxvpdjmdpzii"
  | "jmrvbptzmmarfpvpliqm-signalostech"
  | "jmrvbptzmmarfpvpliqm-signalosio"
  | "jmrvbptzmmarfpvpliqm-luxmed"
  | "tnkdjgksnlhhaaxgdmdj-solenis";

export interface SSOProvider {
  id: string;
  label: string;
}

export type SupabaseProviderConfig =
  | {
      id: SupabaseProviderId;
      supabaseUrl: string;
      anonKey: string;
      isDefault?: boolean;
      ssoClient?: never;
      ssoValidDomains?: never;
      ssoProvider?: never;
    }
  | {
      id: SupabaseProviderId;
      supabaseUrl: string;
      anonKey: string;
      ssoClient: boolean;
      ssoValidDomains: string[];
      ssoProvider: SSOProvider[];
      isDefault?: boolean;
    };

export const SUPABASE_PROVIDERS: SupabaseProviderConfig[] = [
  {
    id: "quiyvrsgsxvpdjmdpzii",
    supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
    anonKey: import.meta.env.VITE_SUPABASE_KEY,
    isDefault: true,
  },
  {
    id: "jmrvbptzmmarfpvpliqm-signalostech",
    supabaseUrl: "https://jmrvbptzmmarfpvpliqm.supabase.co",
    anonKey:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImptcnZicHR6bW1hcmZwdnBsaXFtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY3MjUzNjYsImV4cCI6MjA3MjMwMTM2Nn0.8a0OmnV1n4PGu5JL5L6Ghh8W2SeSjrLnw2zf5I0Hygk",
    ssoClient: true,
    ssoValidDomains: ["signalostech.onmicrosoft.com"],
    ssoProvider: [{ id: "cbd4ac6e-9f8e-46fa-ae0c-0e8439b0b610", label: "SignalOS" }],
  },
  {
    id: "jmrvbptzmmarfpvpliqm-luxmed",
    supabaseUrl: "https://jmrvbptzmmarfpvpliqm.supabase.co",
    anonKey:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImptcnZicHR6bW1hcmZwdnBsaXFtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY3MjUzNjYsImV4cCI6MjA3MjMwMTM2Nn0.8a0OmnV1n4PGu5JL5L6Ghh8W2SeSjrLnw2zf5I0Hygk",
    ssoClient: true,
    ssoValidDomains: ["luxmed.pl"],
    ssoProvider: [{ id: "1945fd5c-3526-489f-abd8-6172bb63f77d", label: "Lux Med" }],
  },
  {
    id: "tnkdjgksnlhhaaxgdmdj-solenis",
    supabaseUrl: "https://tnkdjgksnlhhaaxgdmdj.supabase.co",
    anonKey: "sb_publishable_Qodk-EZribG_0fCS4o-Z8g_1FxBTZwJ",
    ssoClient: true,
    ssoValidDomains: ["solenis.adds.sl", "solenis.com", "contractor.solenis.com"],
    ssoProvider: [{ id: "12140c11-4cc4-4aac-ac70-7a827e27e1c8", label: "Solenis" }],
  },
];
